import { StyledButton } from './style';

import type { Modify } from '@lib/types';
import type { ComponentPropsWithoutRef } from 'react';
import type React from 'react';

export type ButtonProps<AS extends React.ElementType = 'button'> = Modify<
  ComponentPropsWithoutRef<AS>,
  {
    as?: AS;
    primary?: boolean;
    large?: boolean;
    light?: boolean;
    rounded?: boolean;
    iconUrl?: string;
  }
>;

export const Button = <AS extends React.ElementType = 'button'>(
  props: ButtonProps<AS>,
): JSX.Element => {
  const { iconUrl, children } = props;

  return (
    <StyledButton {...props}>
      {iconUrl && <img src={iconUrl} alt="" />}
      {children}
    </StyledButton>
  );
};
